import { render, staticRenderFns } from "./Huayhd.vue?vue&type=template&id=1158113a&scoped=true&"
import script from "./Huayhd.vue?vue&type=script&lang=js&"
export * from "./Huayhd.vue?vue&type=script&lang=js&"
import style0 from "./Huayhd.vue?vue&type=style&index=0&id=1158113a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1158113a",
  null
  
)

export default component.exports